// src/sections/KontaktSection.jsx
import { useState, useEffect } from "react";
import { Box, Heading, VStack, Input, Button, Flex, Text, useDisclosure } from "@chakra-ui/react";
import axios from "axios";
import { showSuccess, showError } from "../utils/toastUtils";


export default function KontaktSection({ anlageId }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [anlageKunden, setAnlageKunden] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({
    kunde: "",
    vertragsbeginn: "",
    leistungKwp: "",
  });
  const [kunden, setKunden] = useState([]);
  const [showKunden, setShowKunden] = useState(false);

  // ✅ LOAD existing data
  useEffect(() => {
    if (!anlageId) return;

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/zuordnungen/anlage/${anlageId}`)
      .then((res) => {
        setAnlageKunden(res.data);
      })
      .catch(() => {
        setAnlageKunden([]);
      });
  }, [anlageId]);


  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/kunden`)
      .then((res) => setKunden(res.data))
      .catch((err) => console.error("Error loading Kunden:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (!name) return;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    const payload = {
      kunde: { id: form.kunde },
      anlage: { id: anlageId },
      vertragsbeginn: form.vertragsbeginn,
      leistungKwp: form.leistungKwp,
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/zuordnungen`,
        payload,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/zuordnungen/anlage/${anlageId}`
      );
      setAnlageKunden(res.data);

      showSuccess("Gespeichert", "Kunde wurde der Anlage zugeordnet");
    } catch {
      showError("Fehler!", "Zuordnung fehlgeschlagen");
    }
  };


  const handleShowKunden = async () => {
    if (!showKunden) {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/zuordnungen/anlage/${anlageId}`);
      setAnlageKunden(res.data);
    }
    setShowKunden(!showKunden);
  };

  return (
    <Box 
      p={8} 
      bg="white" 
      borderRadius="xl" 
      boxShadow="md" 
      mt={6} 
      mb={10} 
      maxW="md"
    >
      <Heading fontSize="24px" mb={4}>
        Kontaktdaten
      </Heading>

      <Flex gap={3} mb={4}>
        <Button 
           bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
        onClick={() => setShowForm(!showForm)}>
          {showForm ? "Formular ausblenden" : "Kunde hinzufügen"}
        </Button>

        <Button 
           bg="#B8860B"
          color="white"
          _hover={{ bg: "#C99414" }}
          size="md"
          onClick={handleShowKunden}>
          {showKunden ? "Kunden ausblenden" : "Kunden anzeigen"}
        </Button>
      </Flex>

      {showForm && (
        <VStack spacing={4} align="stretch">
          <label>Kunde:</label>
          <select name="kunde" value={form.kunde} onChange={handleChange}>
            <option value="">Kunde auswählen</option>
            {kunden.map((k) => (
              <option key={k.id} value={k.id}>
                {k.vorname} {k.nachname}
              </option>
            ))}
          </select>

          <Flex align="center" justify="space-between">
            <label>Vertragsbeginn:</label>
            <Input
              name="vertragsbeginn"
              type="date"
              value={form.vertragsbeginn || ""}
              onChange={handleChange}
              w="60%"
            />
          </Flex>

          <Flex align="center" justify="space-between">
            <label>Kundenspezifische Leistung in kWp:</label>
            <Input
              name="leistungKwp"
              type="number"
              value={form.leistungKwp || ""}
              onChange={handleChange}
              w="60%"
            />
          </Flex>


          <Button colorScheme="blue" mt={4} onClick={handleSave}>
            Kunde in Anlage speichern
          </Button>
        </VStack>
      )}

      {showKunden && (
        <Box mt={4} p={3} borderWidth="1px" borderRadius="md">
          {anlageKunden.length > 0 ? (
            anlageKunden.map((z) => (
              <Text key={z.id}>
                {z.kunde?.vorname} {z.kunde?.nachname} – {z.leistungKwp} kWp
              </Text>
            ))
          ) : (
            <Text>Keine Kunden zugeordnet.</Text>
          )}
        </Box>
      )}

    </Box>
  );
}